import { render, staticRenderFns } from "./LpuSpecializations.vue?vue&type=template&id=4da76bf7&scoped=true&"
import script from "./LpuSpecializations.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuSpecializations.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuSpecializations.vue?vue&type=style&index=0&id=4da76bf7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da76bf7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da76bf7')) {
      api.createRecord('4da76bf7', component.options)
    } else {
      api.reload('4da76bf7', component.options)
    }
    module.hot.accept("./LpuSpecializations.vue?vue&type=template&id=4da76bf7&scoped=true&", function () {
      api.rerender('4da76bf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuSpecializations/LpuSpecializations.vue"
export default component.exports